import doc                    from '@widesk-core/decorators/doc';
import model                  from '@widesk-core/decorators/model';
import FondationsServiceModel from '@/models/FondationsServiceModel';

@model.urnResource('user_reset_password')
@doc.path('/users/reset_password')
export default class UserResetPasswordModel extends FondationsServiceModel {
}